import { useAppDispatch } from '@hooks/redux'
import { useEffect } from 'react'
import { setActiveSection } from '@redux/site/siteSlice'
import { Tabs } from '@components/Tabs/Tabs'
import { Outlet } from 'react-router-dom'
import { RoutePaths } from '@interfaces/routePaths'

export const Incidents = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setActiveSection('Incidents'))
  })

  return (
    <>
      <Tabs
        data={[
          {
            label: 'Source',
            path: `${RoutePaths.ADMIN_SETTINGS}/${RoutePaths.ADMIN_SETTINGS_INCIDENTS}/${RoutePaths.ADMIN_SETTINGS_INCIDENTS_SOURCE}`,
          },
          {
            label: 'Action taken',
            path: `${RoutePaths.ADMIN_SETTINGS}/${RoutePaths.ADMIN_SETTINGS_INCIDENTS}/${RoutePaths.ADMIN_SETTINGS_INCIDENTS_ACTION_TAKEN}`,
          },
        ]}
      />
      <Outlet />
    </>
  )
}
